
import { Component, Vue, Prop, Emit } from 'vue-property-decorator'

@Component({
  components: {
    // 注册组件
  }
})
export default class extends Vue {
  @Prop() visible: boolean

  livedemo: HTMLVideoElement | null
  videoUrl: string = ''

  @Emit('isEnd')
  isEnd() {}

  play() {
    console.log('视频开始播放～')
    this.livedemo?.play()
  }

  init() {
    this.videoUrl = `${this.$store.$global.static}/images/guide/live-video.mp4`
    this.livedemo = document.getElementById('livedemo') as HTMLVideoElement

    // 设置监听播放结束
    this.livedemo &&
      this.livedemo.addEventListener(
        'ended',
        () => {
          this.isEnd()
        },
        false
      )
  }

  mounted() {
    this.init()
  }

  beforeDestroy() {
    // 结束以后释放播放器资源
    this.videoUrl = ''
  }
}
